module.exports = __webpack_public_path__ + "img/TI.818243c1.png";